import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Spacer,
  Td,
  Tr,
  Text,
} from "@chakra-ui/react";
import { FiEye, FiSearch, FiTrash } from "react-icons/fi";
import TableView from "../../components/TableView";
import { useSelector } from "react-redux";
import CustomButton from "../../components/ButtonComp";
import CustomToolTip from "../../components/CustomTooltip";
import { useLocation, useNavigate } from "react-router-dom";
import ConfirmDialog from "../../components/ConfirmDialog";
import { toast } from "react-toastify";
import { get_purchase_list } from "../../redux/purchaseSlice";
import { baseUrl, formatIndianPrice } from "../../utils/utils";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const Purchase = () => {
  const [deleteDialog, setDeleteDialog] = useState(false);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const [rows, setRows] = useState(10);
  const [page, setpage] = useState(1);
  const [initialValue, setInitialValue] = useState(1);
  const [deleteId, setDeleteId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const { purchase_list, total_purchase_count,loading } = useSelector(
    (state) => state.purchase
  );

  const handleDelete = async () => {
    setIsLoading(true);
    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append("action", "delete");
      formData.append("id", deleteId);

      const response = await fetch(baseUrl + `purchase.php`, {
        method: "POST",
        body: formData,
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch product: ${response.statusText}`);
      }

      const result = await response.json();
      if (result?.success) {
        store.dispatch(get_purchase_list({ page: page, rows: rows }));
        toast.success(result?.message);
        setDeleteId(null);
        setDeleteDialog(false);
      } else {
        toast.error(result?.message);
      }
    } catch (error) {
      console.error("Error fetching product:", error);
      toast.error("Failed to load product data", {
        position: "top-right",
        autoClose: 5000,
      });
      navigate("/products");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (location.state?.fromList) {
      const restoredPage = location.state.page || 1;
      const restoredRows = location.state.rows || 5;
      const restoredInitial = location.state.initialValue || 1;

      setpage(restoredPage);
      setRows(restoredRows);
      setInitialValue(restoredInitial);

      store.dispatch(get_purchase_list({ page: restoredPage, rows: restoredRows }));
    } else {
      store.dispatch(get_purchase_list({ page, rows }));
    }
  }, []);

  // ✅ Filter logic (multi-column search)
  const filteredPurchases = purchase_list?.filter((el) => {
    const term = searchTerm.trim().toLowerCase();
    if (!term) return true;

    return (
      el.inv_no?.toLowerCase().includes(term) ||
      el.vendor_name?.toLowerCase().includes(term) ||
      el.inv_date?.toLowerCase().includes(term) ||
      formatIndianPrice(el.total_amount).toLowerCase().includes(term)
    );
  });

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "row"]}
        alignItems={["stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl" flexShrink={0}>Purchase</Heading>

        <Spacer display={["none", "block"]} />

        <Flex direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap">
          <InputGroup
            bg="#f4f5f7"
            borderRadius={5}
            w={["100%", "auto"]}
            maxW="sm"
          >
            <Input
              placeholder="Search by Invoice, Vendor, Amount, or Date..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
          <CustomButton
            title="Add Purchase"
            w={["100%", ""]}
            onClick={() =>
              navigate("/purchase/add-purchase", {
                state: { purchase_list: purchase_list },
              })
            }
          />
        </Flex>
      </Card>

      <div>
      {loading ? (<GasCylinderLoader 
      size="sm"
    loadingText="Loading Customers"
  />):(<>
        <TableView
          headData={[
            "S.No.",
            "Invoice no",
            "vendor id",
            "total amount",
            "invoice date",
            "products",
            "Action",
          ]}
          body={filteredPurchases?.map((el, i) => (
            <Tr key={el.id}>
              <Td textAlign="center">{i + initialValue}</Td>
              <Td textAlign="center">{el.inv_no}</Td>
              <Td textAlign="center">{el.vendor_name}</Td>
              <Td textAlign="center">{formatIndianPrice(el.total_amount)}</Td>
              <Td textAlign="center">{el.inv_date}</Td>
              <Td textAlign="center">{el.details?.length}</Td>

              <Td textAlign="center">
                {
                  <Flex justify={"center"} gap={4}>
                    <CustomToolTip
                      button={
                        <FiEye
                          size={20}
                          cursor={"pointer"}
                          onClick={() =>
                            navigate(`/purchase/detail/${el.id}`, {
                              state: {
                                ...el,
                                page,
                                rows,
                                initialValue,
                                fromList: true
                              }
                            })
                          }
                        />
                      }
                      mess={"View Product"}
                    />
                    {/* <CustomToolTip
                      button={
                        <FiTrash
                          size={20}
                          cursor={"pointer"}
                          color="#F00"
                          onClick={() => {
                            setDeleteId(el.id);
                            setDeleteDialog(true);
                          }}
                        />
                      }
                      mess={"Delete Product"}
                    /> */}
                  </Flex>
                }
              </Td>
            </Tr>
          ))}
          initialValue={initialValue}
          page={page}
          rows={rows}
          total_value={filteredPurchases?.length || total_purchase_count}
          pagination
          onChange={(e) => {
            setInitialValue(1);
            setpage(1);
            store.dispatch(
              get_purchase_list({ page: 1, rows: e.target.value })
            );
            setRows(e.target.value);
          }}
          onPrevious={() => {
            initialValue == 1 ||
              setInitialValue(Number(initialValue) - Number(rows));
            page == 1 || setpage(page - 1);
            page === 1 ||
              store.dispatch(get_purchase_list({ page: page - 1, rows: rows }));
          }}
          onNext={() => {
            rows * page >= total_purchase_count ||
              setInitialValue(Number(initialValue) + Number(rows));
            rows * page >= total_purchase_count || setpage(page + 1);
            rows * page >= total_purchase_count ||
              store.dispatch(get_purchase_list({ page: page + 1, rows: rows }));
          }}
        />
        <ConfirmDialog
          isOpen={deleteDialog}
          onClose={() => setDeleteDialog(false)}
          onConfirm={handleDelete}
          type="delete"
          title="Delete purchase"
          message="Are you sure you want to delete this purchase? This action cannot be undone and will remove all associated data."
          confirmText="Delete"
          cancelText="Cancel"
          isLoading={isLoading}
        />
      </>)}
      
      </div>
    </>
  );
};

export default Purchase;
